export const FREE_PLAY_TOOLTIP_DISPLAYED_NUMBER = 'orbit_free_play_tooltip_displayed_number';
export const FREE_PLAY_TOOLTIP_IS_DISPLAYED_IN_SESSION = 'orbit_free_play_tooltip_is_displayed_in_session';